<fb-rating-stars
  [rating]="value"
  [hasCursorPointer]="true"
  [disable]="disable"
  [readonly]="readonly"
  (changedEvent)="setRating($event)"
></fb-rating-stars>
